import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between align-items-center w-100" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-be flex-column" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Revenue Chart")
    ])
  ])
], -1)
const _hoisted_3 = { class: "card-body py-0" }
const _hoisted_4 = { class: "d-flex flex-column" }
const _hoisted_5 = { class: "d-flex w-100" }
const _hoisted_6 = { class: "w-100 me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BranchesDropdown = _resolveComponent("BranchesDropdown")!
  const _component_RevenueLineChart = _resolveComponent("RevenueLineChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_BranchesDropdown, {
              modelValue: _ctx.query.branchId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.branchId) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_RevenueLineChart, { data: _ctx.statistics }, null, 8, ["data"])
      ])
    ])
  ]))
}